// import React, { useEffect, useState } from "react";

// import { Eye, EyeOff } from "lucide-react";
// import { useDispatch, useSelector } from "react-redux";
// import useApi from "../CustomHooks/useApi";
// import {
//   fetchAepsBalance,
//   fetchWalletBalance,
//   fetchLienBalance,
// } from "../Store/Slices/WalletSlice";

// const WalletOverview = () => {
//   const dispatch = useDispatch();

//   const {
//     merchant_account_no,
//     username,
//   } = useSelector((s) => s.auth.employeeDetails) || {};

//   const {
//     merchant_shop_name,
//   } = useSelector((s) => s.auth.employeeDetails?.others) || {};

//   const { balance, aepsBalance } = useSelector((s) => s.wallet);

//   const [commission, setCommission] = useState(0);
//   const [showBalance, setShowBalance] = useState(false);
//   const [currentTime, setCurrentTime] = useState(new Date());

//   const { callApi: commissionApi } = useApi(
//     `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
//     "GET"
//   );

//   /* ================= TIME ================= */
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentTime(new Date());
//     }, 1000);
//     return () => clearInterval(timer);
//   }, []);

//   /* ================= FETCH BALANCES ================= */
//   // useEffect(() => {
//   //   (async () => {
//   //     const c = await commissionApi();
//   //     setCommission(c?.balance || 0);
//   //   })();

//   //   dispatch(fetchWalletBalance());
//   //   dispatch(fetchAepsBalance());
//   //   dispatch(fetchLienBalance());
//   // }, [dispatch]);


//   const refreshBalances = async () => {
//   const c = await commissionApi();
//   setCommission(c?.balance || 0);

//   dispatch(fetchWalletBalance());
//   dispatch(fetchAepsBalance());
//   dispatch(fetchLienBalance());
// };

// useEffect(() => {
//   refreshBalances();
// }, [dispatch]);

//   /* ================= GREETING ================= */
//   const hours = currentTime.getHours();
//   let greeting = "Good Evening";
//   if (hours < 12) greeting = "Good Morning";
//   else if (hours < 17) greeting = "Good Afternoon";

//   return (
//     <section className="w-full bg-[#F4F6FA] pt-3">
//       {/* ================= DESKTOP (Greeting Only - Centered) ================= */}
//       <div className="hidden sm:block bg-white border border-slate-200 mx-4 mt-2 rounded-xl shadow-sm">
//         <div className="flex items-center justify-between px-4 py-2 text-sm text-slate-700">

//           <div className="flex items-center gap-2">
//             <span className="font-medium">
//               {greeting}, {merchant_shop_name} Ji 👋
//             </span>
//           </div>

//           <div className="text-xs text-slate-500">
//             {currentTime.toLocaleDateString("en-IN")} •{" "}
//             {currentTime.toLocaleTimeString("en-IN")}
//           </div>

//         </div>
//       </div>


//       {/* ================= MOBILE (Greeting + Balance) ================= */}
//       <div className="lg:hidden rounded-2xl overflow-hidden bg-[#162A5C] shadow-md text-white">
//         <div className="px-4 py-4">

//           {/* Greeting */}
//           {/* <div className="text-sm font-medium mb-4">
//             {currentTime.toLocaleDateString("en-IN", {
//               weekday: "long",
//               day: "numeric",
//               month: "long",
//               year: "numeric",
//             })}
//             {" • "}
//             {currentTime.toLocaleTimeString("en-IN")}
//             <br />
//             <span className="font-semibold">
//               {greeting}, {merchant_shop_name} Ji 👋
//             </span>
//           </div> */}
//           {/* Greeting */}
// <div className="flex items-start justify-between mb-4">
  
//   <div className="text-sm font-medium">
//     {currentTime.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     })}
//     {" • "}
//     {currentTime.toLocaleTimeString("en-IN")}
//     <br />

//     <span className="font-semibold">
//       {greeting}, {merchant_shop_name} Ji 👋
//     </span>
//   </div>

//   <button
//     onClick={async () => {
//       setShowBalance((prev) => !prev);
//       await refreshBalances();
//     }}
//     className="bg-white/10 p-2 rounded-lg active:scale-95 transition"
//   >
//     {showBalance ? (
//       <EyeOff size={20} className="text-white" />
//     ) : (
//       <Eye size={20} className="text-white" />
//     )}
//   </button>

// </div>

//           {/* Balances */}
//           <div className="space-y-3 text-sm">

//             <div className="flex justify-between bg-[#1E2F6B] px-4 py-3 rounded-xl">
//               <span className="text-gray-300">Main Balance</span>
//               <span className="font-semibold">
//                 {/* ₹{balance?.toLocaleString() || 0} */}
//                 {showBalance
//   ? `₹${balance?.toLocaleString() || 0}`
//   : "••••••"}
//               </span>
//             </div>

//             <div className="flex justify-between bg-[#1E2F6B] px-4 py-3 rounded-xl">
//               <span className="text-gray-300">AEPS Balance</span>
//               <span className="font-semibold">
//                 {/* ₹{aepsBalance?.toLocaleString() || 0} */}
//                 {showBalance
//   ? `₹${aepsBalance?.toLocaleString() || 0}`
//   : "••••••"}
//               </span>
//             </div>

//             <div className="flex justify-between bg-[#1E2F6B] px-4 py-3 rounded-xl">
//               <span className="text-gray-300">Commission Balance</span>
//               <span className="font-semibold">
//                 {/* ₹{commission?.toLocaleString() || 0} */}
//                 {showBalance
//   ? `₹${commission?.toLocaleString() || 0}`
//   : "••••••"}
//               </span>
//             </div>

//           </div>

//         </div>
//       </div>

//     </section>
//   );

// };

// export default WalletOverview;




// new ui 
import React, { useEffect, useState } from "react";
import { Eye, EyeOff, Wallet, Landmark, BadgePercent, RotateCw } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../CustomHooks/useApi";
import {
  fetchAepsBalance,
  fetchWalletBalance,
  fetchLienBalance,
} from "../Store/Slices/WalletSlice";

const WalletOverview = () => {
  const dispatch = useDispatch();

  const { merchant_account_no, username } =
    useSelector((s) => s.auth.employeeDetails) || {};

  const { merchant_shop_name } =
    useSelector((s) => s.auth.employeeDetails?.others) || {};

  const { balance, aepsBalance } = useSelector((s) => s.wallet);

  const [commission, setCommission] = useState(0);
  const [showBalance, setShowBalance] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isRefreshing, setIsRefreshing] = useState(false);

  const { callApi: commissionApi } = useApi(
    `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
    "GET"
  );

  /* ================= TIME ================= */
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const refreshBalances = async () => {
    setIsRefreshing(true);
    try {
      // The other balances do not depend on this one, and a failing call (gateway restarting, no network) must not
      // become an uncaught error that covers the whole page.
      dispatch(fetchWalletBalance());
      dispatch(fetchAepsBalance());
      dispatch(fetchLienBalance());
      const c = await commissionApi();
      setCommission(c?.balance || 0);
    } catch (err) {
      console.warn("Balance refresh failed:", err?.message || err);
    } finally {
      setTimeout(() => setIsRefreshing(false), 500);
    }
  };

  useEffect(() => {
    refreshBalances();
  }, [dispatch]);

  /* ================= GREETING ================= */
  const hours = currentTime.getHours();
  let greeting = "Good Evening";
  if (hours < 12) greeting = "Good Morning";
  else if (hours < 17) greeting = "Good Afternoon";

  return (
    <section className="w-full space-y-4">
      {/* Top Welcome Bar */}
      <div className="bg-white/80 backdrop-blur-md border border-slate-200/80 rounded-2xl p-4 shadow-xs flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-tr from-blue-600 to-indigo-600 flex items-center justify-center text-white font-bold text-lg shadow-sm">
            {merchant_shop_name ? merchant_shop_name.charAt(0).toUpperCase() : "M"}
          </div>
          <div>
            <h2 className="text-base font-semibold text-slate-800 flex items-center gap-1.5">
              {greeting}, {merchant_shop_name || "Merchant"} Ji 👋
            </h2>
            <p className="text-xs text-slate-400 font-medium">
              {currentTime.toLocaleDateString("en-IN", {
                weekday: "short",
                day: "numeric",
                month: "short",
                year: "numeric",
              })}{" "}
              • {currentTime.toLocaleTimeString("en-IN")}
            </p>
          </div>
        </div>

        {/* Action Controls: Refresh is visible on all screens; Balance Toggle button is visible only on Mobile/Tablet */}
        <div className="flex items-center gap-2">
          <button
            onClick={refreshBalances}
            title="Refresh Balances"
            className="p-2.5 rounded-xl border border-slate-200 hover:bg-slate-50 text-slate-600 transition active:scale-95"
          >
            <RotateCw className={`w-4 h-4 ${isRefreshing ? "animate-spin text-blue-600" : ""}`} />
          </button>
          <button
            onClick={() => {
              setShowBalance((prev) => !prev);
              refreshBalances();
            }}
            className="sm:hidden flex items-center gap-2 px-3.5 py-2 rounded-xl bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800 transition active:scale-95 shadow-xs"
          >
            {showBalance ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            <span>{showBalance ? "Hide Balance" : "Show Balance"}</span>
          </button>
        </div>
      </div>

      {/* ================= MOBILE-ONLY BALANCES (Hidden on sm: and above) ================= */}
      <div className="grid grid-cols-1 gap-3.5 sm:hidden">
        {/* Main Wallet Card */}
        <div className="relative overflow-hidden bg-gradient-to-br from-slate-900 to-[#122B48] text-white p-4 rounded-2xl shadow-sm border border-slate-800 flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <span className="text-xs font-medium text-slate-300 uppercase tracking-wider">
              Main Balance
            </span>
            <div className="p-2 rounded-xl bg-white/10 text-blue-300 backdrop-blur-xs">
              <Wallet className="w-4 h-4" />
            </div>
          </div>
          <div className="mt-3">
            <div className="text-2xl font-bold tracking-tight text-white">
              {showBalance ? `₹${(balance || 0).toLocaleString("en-IN")}` : "••••••••"}
            </div>
            <p className="text-[11px] text-slate-400 mt-0.5">Primary transacting account</p>
          </div>
        </div>

        {/* AEPS Balance Card */}
        <div className="relative overflow-hidden bg-white border border-slate-200/80 p-4 rounded-2xl shadow-xs flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">
              AEPS Balance
            </span>
            <div className="p-2 rounded-xl bg-emerald-50 text-emerald-600">
              <Landmark className="w-4 h-4" />
            </div>
          </div>
          <div className="mt-3">
            <div className="text-2xl font-bold tracking-tight text-slate-900">
              {showBalance ? `₹${(aepsBalance || 0).toLocaleString("en-IN")}` : "••••••••"}
            </div>
            <p className="text-[11px] text-slate-400 mt-0.5">Settlement wallet</p>
          </div>
        </div>

        {/* Commission Balance Card */}
        <div className="relative overflow-hidden bg-white border border-slate-200/80 p-4 rounded-2xl shadow-xs flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">
              Commission Balance
            </span>
            <div className="p-2 rounded-xl bg-amber-50 text-amber-600">
              <BadgePercent className="w-4 h-4" />
            </div>
          </div>
          <div className="mt-3">
            <div className="text-2xl font-bold tracking-tight text-slate-900">
              {showBalance ? `₹${(commission || 0).toLocaleString("en-IN")}` : "••••••••"}
            </div>
            <p className="text-[11px] text-slate-400 mt-0.5">Earned incentives</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WalletOverview;